import { PropsWithChildren, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useIsMounted } from '@toss/react';
interface SSRSafeTranslationGuardProps extends PropsWithChildren {
  fallback?: ReactNode;
}
export const SSRSafeTranslationGuard = (props: SSRSafeTranslationGuardProps) => {
  const {
    ready
  } = useTranslation();
  const isMounted = useIsMounted();
  if (isMounted && ready) {
    return props.children;
  }
  return <>{props.fallback}</>;
};